import { createRelayResource } from '@townsquare/relay-utils';
import type { ResourceContext } from '@townsquare/router/types';
import { tqlQueryFromInput } from '@townsquare/tql/query';
import { ComparatorOperator as CO } from '@townsquare/tql/types';
import type { User } from '@townsquare/user-store/types';

import StatusUpdatesNavigationQuery, {
	type SavedTabs_savedQuery as StatusUpdatesNavigationQueryType,
} from '../StatusUpdatesNavigation/__generated__/SavedTabs_savedQuery.graphql';

const favoriteViewsTqlQuery = (
	user: User,
	townsquareApp: 'home' | 'goals' | 'projects' | 'teams' | 'teams-isolated',
) =>
	tqlQueryFromInput({
		input: [
			{ fieldName: 'favouritedBy', fieldValue: user.accountId, comparator: CO.EQUALS },
			...(townsquareApp === 'projects' || townsquareApp === 'goals'
				? [
						{
							fieldName: 'entityType',
							fieldValue: townsquareApp === 'goals' ? 'GOAL' : 'PROJECT',
							comparator: CO.EQUALS,
						},
					]
				: []),
		],
	});

export const statusUpdatesNavigationResource =
	createRelayResource<StatusUpdatesNavigationQueryType>({
		getQuery: (_, resourceContext) => {
			const { workspace, user, townsquareApp } = resourceContext as ResourceContext;
			const savedViewTql = favoriteViewsTqlQuery(user, townsquareApp);

			return {
				query: StatusUpdatesNavigationQuery,
				variables: {
					workspaceId: workspace?.globalId,
					workspaceUuid: workspace?.UUID ?? '',
					savedViewTql,
					cloudId: workspace?.cloudId,
					tagsAndTeamsEnabled: townsquareApp === 'home',
				},
			};
		},
	});
